import React from "react";
import {useFormContext} from "react-hook-form";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import * as CustomStyles from '../../styles/CustomStyles';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import {getGeoLocation} from '../../util/Calculators';
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as DataPattern from '../../constants/DataPattern';




//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errsrs, etc...) by using useFormContext()
// lEmployer is expected to be in the local form state
//

export function RenderDateGeneraleSection(props) {
    console.log('Date Generale');
    const { register, formState: { errors, defaultValues } } = useFormContext();

    const clientSelectData = props.clients.map( (client) => ({ id: client.id, name: client.generalSection.clientName }));

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={12}>
                    <TextField variant="standard" size="small" label="Nume Angajator" fullWidth margin="dense" 
                        {...register("lEmployer.generalSection.employerName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployer?.generalSection?.employerName}
                        helperText={errors?.lEmployer?.generalSection?.employerName ? errors.lEmployer.generalSection.employerName.message : null}
                    />
                </Grid>
                {/*row*/}
                <Grid item xs={6}>
                    <TextField variant="standard" size="small" label="Nr. Registrul Comertului" fullWidth margin="dense" 
                        {...register("lEmployer.generalSection.registrulComertului", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployer?.generalSection?.registrulComertului}
                        helperText={errors?.lEmployer?.generalSection?.registrulComertului ? errors.lEmployer.generalSection.registrulComertului.message : null}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField variant="standard" size="small" label="Cod Unic de Inregistrare (CUI)" fullWidth margin="dense" 
                        {...register("lEmployer.generalSection.codUnic", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployer?.generalSection?.codUnic}
                        helperText={errors?.lEmployer?.generalSection?.codUnic ? errors.lEmployer.generalSection.codUnic.message : null}
                    />
                </Grid>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume Reprezentant Legal" fullWidth margin="dense" 
                        {...register("lEmployer.generalSection.legalRepresentativeName")} 
                        error={!!errors?.lEmployer?.generalSection?.legalRepresentativeName}
                        helperText={errors?.lEmployer?.generalSection?.legalRepresentativeName ? errors.lEmployer.generalSection.legalRepresentativeName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Telefon Reprezentant Legal" fullWidth margin="dense" 
                        {...register("lEmployer.generalSection.legalRepresentativePhone",
                            {pattern: {
                                value: DataPattern.PATTERN_PHONE_NUMBER,
                                message: ValidationMessages.INVALID_PHONE_NUMBER,
                            }}
                        )} 
                        error={!!errors?.lEmployer?.generalSection?.legalRepresentativePhone}
                        helperText={errors?.lEmployer?.generalSection?.legalRepresentativePhone ? errors.lEmployer.generalSection.legalRepresentativePhone.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Email Reprezentant Legal" fullWidth margin="dense" 
                        {...register("lEmployer.generalSection.legalRepresentativeEmail",
                            {pattern: {
                                value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                            }}
                        )} 
                        error={!!errors?.lEmployer?.generalSection?.legalRepresentativeEmail}
                        helperText={errors?.lEmployer?.generalSection?.legalRepresentativeEmail ? errors.lEmployer.generalSection.legalRepresentativeEmail.message : null}
                    />
                </Grid>
                {/*row*/}
                <Grid item xs={6}>
                    <TextField variant="standard" size="small" label="Cont Bancar" fullWidth margin="dense" 
                        {...register("lEmployer.generalSection.bankingInfo")} 
                        error={!!errors?.lEmployer?.generalSection?.bankingInfo}
                        helperText={errors?.lEmployer?.generalSection?.bankingInfo ? errors.lEmployer.generalSection.bankingInfo.message : null}
                    />
                </Grid>
                <Grid item xs={6}>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <CustomSelect 
                        disabled={!!defaultValues.lEmployer.id}
                        selectId={'rsvtiMBClientId'} 
                        selectData={ {dataArray: clientSelectData, label: "RSVTI Managed By"}} 
                        value={defaultValues.lEmployer.generalSection.rsvtiMBClientId} 
                        register={{...register('lEmployer.generalSection.rsvtiMBClientId', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lEmployer?.generalSection?.rsvtiMBClientId}
                        helperText={errors?.lEmployer?.generalSection?.rsvtiMBClientId ? errors.lEmployer.generalSection.rsvtiMBClientId.message : null}
                    />   
                </Grid>
                <Grid item xs={8}>
                </Grid>

            </Grid>
        </Box>
    );
}


export function RenderAdresaSediuSection() {
    console.log('Adresa Sediu ');
    const { register, setValue, watch, trigger, formState: { errors, defaultValues } } = useFormContext();

    const [checkedWorkSite, setCheckedWorkSite] = React.useState(!!defaultValues.lEmployer.headOffice.isWorkSite ? defaultValues.lEmployer.headOffice.isWorkSite: false);


    const handleJudetChange = (judet) => {
        setValue('lEmployer.headOffice.localizareGeografica', getGeoLocation(judet));
        trigger('lEmployer.headOffice.localizareGeografica');
        // trigger('headofficeJudet-inputLabelId');
    }


    return(
        <Box sx={CustomStyles.boxStyles}  >
          <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Adresa Sediu</Typography>

          <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            {/*row*/}
            <Grid item xs={4}>
                <CustomSelect 
                    callback={handleJudetChange}
                    selectId={'headofficeJudet'} 
                    selectType={SelectTypes.JUDETE} 
                    value={defaultValues.lEmployer.headOffice.judet} 
                    register={{...register('lEmployer.headOffice.judet', {required: ValidationMessages.REQUITED_MESSAGE})}}
                    error={!!errors?.lEmployer?.headOffice?.judet}
                    helperText={errors?.lEmployer?.headOffice?.judet ? errors.lEmployer?.headOffice?.judet.message : null}
                />   
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Localizare Geografica" fullWidth margin="dense" disabled
                    {...register("lEmployer.headOffice.localizareGeografica", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lEmployer?.headOffice?.localizareGeografica}
                    helperText={errors?.errors?.lEmployer?.headOffice?.localizareGeografica ? errors.errors?.lEmployer?.headOffice?.localizareGeografica.message : null}
                    inputRef={register()}
                    InputLabelProps={{ shrink: !!watch('lEmployer.headOffice.localizareGeografica') }}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Localitate" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.localitate", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lEmployer?.headOffice?.localitate}
                    helperText={errors?.lEmployer?.headOffice?.localitate ? errors.lEmployer?.headOffice?.localitate.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Sector" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.sector")} 
                    error={!!errors?.lEmployer?.headOffice?.sector}
                    helperText={errors?.lEmployer?.headOffice?.sector ? errors.lEmployer?.headOffice?.sector.message : null}
                />
            </Grid>

            {/*row*/}
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Cod Postal" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.postalCode", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployer?.headOffice?.postalCode}
                    helperText={errors?.lEmployer?.headOffice?.postalCode ? errors.lEmployer?.headOffice?.postalCode.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Strada" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.street", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lEmployer?.headOffice?.street}
                    helperText={errors?.lEmployer?.headOffice?.street ? errors.lEmployer?.headOffice?.street.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Nr." fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.no", {required: ValidationMessages.REQUITED_MESSAGE})} 
                    error={!!errors?.lEmployer?.headOffice?.no}
                    helperText={errors?.lEmployer?.headOffice?.no ? errors.lEmployer?.headOffice?.no.message : null}
                />
            </Grid>


            {/*row*/}
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Bloc" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.bloc")} 
                    error={!!errors?.lEmployer?.headOffice?.bloc}
                    helperText={errors?.lEmployer?.headOffice?.bloc ? errors.lEmployer?.headOffice?.bloc.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Scara" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.scara")} 
                    error={!!errors?.lEmployer?.headOffice?.scara}
                    helperText={errors?.lEmployer?.headOffice?.scara ? errors.lEmployer?.headOffice?.scara.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Etaj" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.etaj")} 
                    error={!!errors?.lEmployer?.headOffice?.etaj}
                    helperText={errors?.lEmployer?.headOffice?.etaj ? errors.lEmployer?.headOffice?.etaj.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Apartament" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.apartment")} 
                    error={!!errors?.lEmployer?.headOffice?.apartment}
                    helperText={errors?.lEmployer?.headOffice?.apartment ? errors.lEmployer?.headOffice?.apartment.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Buzzer" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.buzzer")} 
                    error={!!errors?.lEmployer?.headOffice?.buzzer}
                    helperText={errors?.lEmployer?.headOffice?.buzzer ? errors.lEmployer?.headOffice?.buzzer.message : null}
                />
            </Grid>
            <Grid item xs={2}>
            </Grid>

            {/*row*/}
            <Grid item xs={3}>
                <TextField variant="standard" size="small" label="Telefon" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.phone", 
                        {required: ValidationMessages.REQUITED_MESSAGE,
                            pattern: {
                                value: DataPattern.PATTERN_PHONE_NUMBER,
                                message: ValidationMessages.INVALID_PHONE_NUMBER,
                            }  
                        }
                    )} 
                    error={!!errors?.lEmployer?.headOffice?.phone}
                    helperText={errors?.lEmployer?.headOffice?.phone ? errors.lEmployer?.headOffice?.phone.message : null}
                />
            </Grid>
            <Grid item xs={1}>
                <TextField variant="standard" size="small" label="Interior" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.phoneExtension")} 
                    error={!!errors?.lEmployer?.headOffice?.phoneExtension}
                    helperText={errors?.lEmployer?.headOffice?.phoneExtension ? errors.lEmployer?.headOffice?.phoneExtension.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Fax" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.fax")} 
                    error={!!errors?.lEmployer?.headOffice?.fax}
                    helperText={errors?.lEmployer?.headOffice?.fax ? errors.lEmployer?.headOffice?.fax.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Email" fullWidth margin="dense" 
                    {...register("lEmployer.headOffice.email", 
                        {required: ValidationMessages.REQUITED_MESSAGE,               
                         pattern: {
                            value: DataPattern.PATTERN_EMAIL_ADDRESS,
                            message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                         }  
                        }
                    )} 
                    error={!!errors?.lEmployer?.headOffice?.email}
                    helperText={errors?.lEmployer?.headOffice?.email ? errors.lEmployer?.headOffice?.email.message : null}
                />
            </Grid>


            {/*row*/}
            <Grid item xs={4}>
                <FormControlLabel 
                    control={ 
                        <Checkbox
                            {...register('lEmployer.headOffice.isWorkSite')}                         
                            checked={checkedWorkSite} 
                            onChange={(event) => setCheckedWorkSite(event.target.checked)}
                        /> 
                    } 
                    label="Punct de Lucru" 
                />
            </Grid>
            <Grid item xs={8}>
            </Grid>

          </Grid>
        </Box>
    );
}



export function RenderDateCaracterizareSection() {
    const { register, formState: { errors, defaultValues } } = useFormContext();

    return(
        <React.Fragment>
        <Box sx={CustomStyles.boxStyles} >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Date de Caracterizare</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'caracterizareTipAngajator'} 
                        selectType={SelectTypes.EMPLOYER_TYPE} 
                        value={defaultValues.lEmployer.caracterizare.tipAngajator} 
                        register={{...register('lEmployer.caracterizare.tipAngajator', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                        error={!!errors?.lEmployer?.caracterizare?.tipAngajator}
                        helperText={errors?.lEmployer?.caracterizare?.tipAngajator ? errors.lEmployer?.caracterizare?.tipAngajator.message : null}
                        />
                </Grid>
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'caracterizareFormaJuridica'} 
                        selectType={SelectTypes.FORMA_JURIDICA} 
                        value={defaultValues.lEmployer.caracterizare.formaJuridica} 
                        register={{...register('lEmployer.caracterizare.formaJuridica', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                        error={!!errors?.lEmployer?.caracterizare?.formaJuridica}
                        helperText={errors?.lEmployer?.caracterizare?.formaJuridica ? errors.lEmployer?.caracterizare?.formaJuridica.message : null}
                        />
                </Grid>
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'caracterizareFormaProprietate'} 
                        selectType={SelectTypes.PROPERTY_TYPE} 
                        value={defaultValues.lEmployer.caracterizare.formaProprietate} 
                        register={{...register('lEmployer.caracterizare.formaProprietate', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                        error={!!errors?.lEmployer?.caracterizare?.formaProprietate}
                        helperText={errors?.lEmployer?.caracterizare?.formaProprietate ? errors.lEmployer?.caracterizare?.formaProprietate.message : null}
                        />
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Denumire Angajator Tutelar" fullWidth margin="dense" 
                    {...register("lEmployer.caracterizare.denumireAngajatorTutelar")} 
                    error={!!errors?.lEmployer?.caracterizare?.denumireAngajatorTutelar}
                    helperText={errors?.lEmployer?.caracterizare?.denumireAngajatorTutelar ? errors.lEmployer?.caracterizare?.denumireAngajatorTutelar.message : null}
                />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="CNP/CUI Angajator Tutelar" fullWidth margin="dense" 
                        {...register("lEmployer.caracterizare.cnpAngajatorTutelar")} 
                        error={!!errors?.lEmployer?.caracterizare?.cnpAngajatorTutelar}
                        helperText={errors?.lEmployer?.caracterizare?.cnpAngajatorTutelar ? errors.lEmployer?.caracterizare?.cnpAngajatorTutelar.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'caracterizareJudetAngajatorTutelar'} 
                        selectType={SelectTypes.JUDETE} 
                        value={defaultValues.lEmployer.caracterizare.judetAngajatorTutelar} 
                        register={{...register('lEmployer.caracterizare.judetAngajatorTutelar')}}
                    />
                </Grid>
            </Grid>
        </Box>

        <Box sx={CustomStyles.boxStyles} >
        <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Date Despre Activitatile Economice</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={3} direction="column" container justifyContent="center">
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Activitatea economică principală</Typography>
                </Grid>
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Diviziunea" fullWidth margin="dense" 
                        {...register("lEmployer.activitateEconomica.activitatePrincipala.diviziunea", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                        error={!!errors?.lEmployer?.activitateEconomica?.activitatePrincipala?.diviziunea}
                        helperText={errors?.lEmployer?.activitateEconomica?.activitatePrincipala?.diviziunea ? errors.lEmployer?.activitateEconomica?.activitatePrincipala?.diviziunea.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Grupa" fullWidth margin="dense" 
                        {...register("lEmployer.activitateEconomica.activitatePrincipala.grupa", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                        error={!!errors?.lEmployer?.activitateEconomica?.activitatePrincipala?.grupa}
                        helperText={errors?.lEmployer?.activitateEconomica?.activitatePrincipala?.grupa ? errors.lEmployer?.activitateEconomica?.activitatePrincipala?.grupa.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Clasa" fullWidth margin="dense" 
                        {...register("lEmployer.activitateEconomica.activitatePrincipala.clasa", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                        error={!!errors?.lEmployer?.activitateEconomica?.activitatePrincipala?.clasa}
                        helperText={errors?.lEmployer?.activitateEconomica?.activitatePrincipala?.clasa ? errors.lEmployer?.activitateEconomica?.activitatePrincipala?.clasa.message : null}
                    />
                </Grid>

                {/*row*/}
                <Grid item xs={6}>
                    <TextField variant="standard" size="small" label="Numar Angajati" fullWidth margin="dense" 
                        {...register("lEmployer.activitateEconomica.noAngajati", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                        error={!!errors?.lEmployer?.activitateEconomica?.noAngajati}
                        helperText={errors?.lEmployer?.activitateEconomica?.noAngajati ? errors.lEmployer?.activitateEconomica?.noAngajati.message : null}
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomSelect 
                        selectId={'aeDimensiuneIntreprindere'} 
                        selectType={SelectTypes.EMPLOYER_SIZE} 
                        value={defaultValues.lEmployer.activitateEconomica.dimensiuneIntreprindere} 
                        register={{...register('lEmployer.activitateEconomica.dimensiuneIntreprindere', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                        error={!!errors?.lEmployer?.activitateEconomica?.dimensiuneIntreprindere}
                        helperText={errors?.lEmployer?.activitateEconomica?.dimensiuneIntreprindere ? errors.lEmployer?.activitateEconomica?.dimensiuneIntreprindere.message : null}
                    />
                </Grid>
            </Grid>
        </Box>
        </React.Fragment>
    );
}


export function RenderActivitatiProtectieSection() {
    const { register, formState: { errors, defaultValues } } = useFormContext();

    const [checkedCSSM, setCheckedCSSM] = React.useState(!!defaultValues.lEmployer.organizareActivitateProtectie.cssm ? defaultValues.lEmployer.organizareActivitateProtectie.cssm : false);
    const handleChangeCSSM = (event) => {
        setCheckedCSSM(event.target.checked);
    };
  
    const [checkedServiciiInterne, setCheckedServiciiInterne] = React.useState(!!defaultValues.lEmployer.organizareActivitateProtectie.serviciiInterne ? defaultValues.lEmployer.organizareActivitateProtectie.serviciiInterne : false);
    const handleChangeServiciiInterne = (event) => {
        setCheckedServiciiInterne(event.target.checked);
    };
  
    const [checkedServiciiExterne, setCheckedServiciiExterne] = React.useState(!!defaultValues.lEmployer.organizareActivitateProtectie.serviciiExterne ? defaultValues.lEmployer.organizareActivitateProtectie.serviciiExterne : false);
    const handleChangeServiciiExterne = (event) => {
        setCheckedServiciiExterne(event.target.checked);
    };

    const [checkedAsumareDeAngajator, setCheckedAsumareDeAngajator] = React.useState(!!defaultValues.lEmployer.organizareActivitateProtectie.asumareDeAngajator ? defaultValues.lEmployer.organizareActivitateProtectie.asumareDeAngajator : false);
    const handleChangeAsumareDeAngajator = (event) => {
        setCheckedAsumareDeAngajator(event.target.checked);
    };

    console.log('Activitate prevenire si Protectie: ');

    return(
        <Box sx={CustomStyles.boxStyles} >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Organizarea Activitati de Preventie şi Protecţie</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={3}>
                    <FormControlLabel 
                        control={ 
                            <Checkbox {...register('lEmployer.organizareActivitateProtectie.cssm')}                         
                                checked={checkedCSSM} 
                                onChange={handleChangeCSSM}
                            /> 
                        } 
                        label="CSSM" 
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel 
                        control={ <Checkbox {...register('lEmployer.organizareActivitateProtectie.serviciiInterne')} 
                                    checked={checkedServiciiInterne}
                                    onChange={handleChangeServiciiInterne}
                                  />
                        } 
                        label="Servicii interne" 
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel 
                        control={ <Checkbox {...register('lEmployer.organizareActivitateProtectie.serviciiExterne')} 
                                    checked={checkedServiciiExterne}
                                    onChange={handleChangeServiciiExterne}
                        /> 
                        } 
                        label="Servicii externe" 
                    />
                </Grid>
                <Grid item xs={3} direction="column" container justifyContent="center">
                </Grid>

                {/*row*/}
                <Grid item xs={3}>
                    <FormControlLabel 
                        control={ <Checkbox {...register('lEmployer.organizareActivitateProtectie.asumareDeAngajator')} 
                                    checked={checkedAsumareDeAngajator} 
                                    onChange={handleChangeAsumareDeAngajator}
                                    /> 
                        } 
                        label="Asumare de către angajator" 
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField variant="standard" size="small" label="Nr. lucratori desemnati" fullWidth margin="dense" 
                        {...register("lEmployer.organizareActivitateProtectie.lucratoriDesemnati", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                        error={!!errors?.lEmployer?.organizareActivitateProtectie?.lucratoriDesemnati}
                        helperText={errors?.lEmployer?.organizareActivitateProtectie?.lucratoriDesemnati ? errors.lEmployer?.organizareActivitateProtectie?.lucratoriDesemnati.message : null}
                    />
                </Grid>
                <Grid item xs={7}>
                </Grid>

            </Grid>
        </Box>
    );
}
    

export function RenderMedicinaMunciiSection() {
    console.log('Medicina Muncii');
    const { register, formState: { errors, defaultValues } } = useFormContext();

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Medicina Muncii</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            {/*row*/}
            <Grid item xs={12}>
                <TextField variant="standard" size="small" label="Responsabil Medicina Muncii" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.responsabil", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.responsabil}
                    helperText={errors?.lEmployer?.medicinaMuncii?.responsabil ? errors.lEmployer?.medicinaMuncii?.responsabil.message : null}
                />
            </Grid>

            {/*row*/}
            <Grid item xs={2}>
                <CustomSelect 
                    selectId={'mmJudet'} 
                    selectType={SelectTypes.JUDETE} 
                    value={defaultValues.lEmployer.medicinaMuncii.judet} 
                    register={{...register('lEmployer.medicinaMuncii.judet', /*{required: ValidationMessages.REQUITED_MESSAGE}*/)}}
                    error={!!errors?.lEmployer?.medicinaMuncii?.judet}
                    helperText={errors?.lEmployer?.medicinaMuncii?.judet ? errors.lEmployer?.medicinaMuncii?.judet.message : null}
                />   
            </Grid>
            <Grid item xs={3}>
                <TextField variant="standard" size="small" label="Localitate" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.localitate", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.localitate}
                    helperText={errors?.lEmployer?.medicinaMuncii?.localitate ? errors.lEmployer?.medicinaMuncii?.localitate.message : null}
                />
            </Grid>
            <Grid item xs={0.75}>
                <TextField variant="standard" size="small" label="Sector" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.sector")} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.sector}
                    helperText={errors?.lEmployer?.medicinaMuncii?.sector ? errors.lEmployer?.medicinaMuncii?.sector.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Strada" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.street", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.street}
                    helperText={errors?.lEmployer?.medicinaMuncii?.street ? errors.lEmployer?.medicinaMuncii?.street.message : null}
                />
            </Grid>
            <Grid item xs={0.75}>
                <TextField variant="standard" size="small" label="Nr." fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.no")} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.no}
                    helperText={errors?.lEmployer?.medicinaMuncii?.no ? errors.lEmployer?.medicinaMuncii?.no.message : null}
                />
            </Grid>
            <Grid item xs={1.5}>
                <TextField variant="standard" size="small" label="Cod Postal" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.postalCode", /*{required: ValidationMessages.REQUITED_MESSAGE}*/)} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.postalCode}
                    helperText={errors?.lEmployer?.medicinaMuncii?.postalCode ? errors.lEmployer?.medicinaMuncii?.postalCode.message : null}
                />
            </Grid>

            {/*row*/}
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Bloc" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.bloc")} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.bloc}
                    helperText={errors?.lEmployer?.medicinaMuncii?.bloc ? errors.lEmployer?.medicinaMuncii?.bloc.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Scara" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.scara")} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.scara}
                    helperText={errors?.lEmployer?.medicinaMuncii?.scara ? errors.lEmployer?.medicinaMuncii?.scara.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Etaj" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.etaj")} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.etaj}
                    helperText={errors?.lEmployer?.medicinaMuncii?.etaj ? errors.lEmployer?.medicinaMuncii?.etaj.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Apartament" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.apartment")} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.apartment}
                    helperText={errors?.lEmployer?.medicinaMuncii?.apartment ? errors.lEmployer?.medicinaMuncii?.apartment.message : null}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField variant="standard" size="small" label="Buzzer" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.buzzer")} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.buzzer}
                    helperText={errors?.lEmployer?.medicinaMuncii?.buzzer ? errors.lEmployer?.medicinaMuncii?.buzzer.message : null}
                />
            </Grid>
            <Grid item xs={2}>
            </Grid>

            {/*row*/}
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Telefon" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.phone", 
                    {/*required: ValidationMessages.REQUITED_MESSAGE,*/
                        pattern: {
                            value: DataPattern.PATTERN_PHONE_NUMBER,
                            message: ValidationMessages.INVALID_PHONE_NUMBER,
                        }  
                    }
                    )} 
                    error={!!errors?.lEmployer?.medicinaMuncii?.phone}
                    helperText={errors?.lEmployer?.medicinaMuncii?.phone ? errors.lEmployer?.medicinaMuncii?.phone?.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Email" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.email", 
                    {/*required: ValidationMessages.REQUITED_MESSAGE,*/               
                        pattern: {
                            value: DataPattern.PATTERN_EMAIL_ADDRESS,
                            message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                        }  
                    }
                )} 
                error={!!errors?.lEmployer?.medicinaMuncii?.email}
                helperText={errors?.lEmployer?.medicinaMuncii?.email ? errors.lEmployer?.medicinaMuncii?.email?.message : null}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField variant="standard" size="small" label="Website" fullWidth margin="dense" 
                    {...register("lEmployer.medicinaMuncii.website")}
                />
            </Grid>

            </Grid>
        </Box>
    );

}

export function RenderPreferenceSection() {
    console.log('Preferinte');
    const { register, formState: { errors, defaultValues } } = useFormContext();

    return(
        <React.Fragment>
        <Box sx={CustomStyles.boxStyles} >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Preferinte Angajator</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Prefix Angajator" fullWidth margin="dense" 
                        {...register("lEmployer.preference.prefixEmployer", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lEmployer?.preference?.prefixEmployer}
                        helperText={errors?.lEmployer?.preference?.prefixEmployer ? errors.lEmployer?.preference?.prefixEmployer.message : null}
                    />
                </Grid>
                <Grid item xs={8}>
                </Grid>

                {/*row*/}
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Offset Reminder Autorizatie (Saptamani)" fullWidth margin="dense" 
                        {...register("lEmployer.preference.offsetAuthorizationRenewal", 
                            {   valueAsNumber: true,
                                required: ValidationMessages.REQUITED_MESSAGE,
                                validate: (value) => value > 0 ? true : ValidationMessages.INVALID_INTEGER,
                            }
                        )} 

                        error={!!errors?.lEmployer?.preference?.offsetAuthorizationRenewal}
                        helperText={errors?.lEmployer?.preference?.offsetAuthorizationRenewal ? errors.lEmployer.preference.offsetAuthorizationRenewal.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Offset Reminder Talon (Saptamani)" fullWidth margin="dense" 
                        {...register("lEmployer.preference.offsetCouponRenewal", 
                            {   valueAsNumber: true,
                                required: ValidationMessages.REQUITED_MESSAGE,
                                validate: (value) => value > 0 ? true : ValidationMessages.INVALID_INTEGER,
                            }
                        )} 
                        error={!!errors?.lEmployer?.preference?.offsetCouponRenewal}
                        helperText={errors?.lEmployer?.preference?.offsetCouponRenewal ? errors.lEmployer?.preference?.offsetCouponRenewal.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Offset Reminder Viza Talon (Saptamani)" fullWidth margin="dense" 
                        {...register("lEmployer.preference.offsetCouponStampRenewal", 
                            {   valueAsNumber: true,
                                required: ValidationMessages.REQUITED_MESSAGE,
                                validate: (value) => value > 0 ? true : ValidationMessages.INVALID_INTEGER,
                            }
                        )} 
                        error={!!errors?.lEmployer?.preference?.offsetCouponStampRenewal}
                        helperText={errors?.lEmployer?.preference?.offsetCouponStampRenewal ? errors.lEmployer?.preference?.offsetCouponStampRenewal.message : null}
                    />
                </Grid>
                <Grid item xs={3}>
                </Grid>

                {/*row*/}
                <Grid item xs={3}>
                    <TextField variant="standard" size="small" label="Offset Reminder Adeverinta (Saptamani)" fullWidth margin="dense" 
                        {...register("lEmployer.preference.offsetCertificateRenewal", 
                            {   valueAsNumber: true,
                                required: ValidationMessages.REQUITED_MESSAGE,
                                validate: (value) => value > 0 ? true : ValidationMessages.INVALID_INTEGER,
                            }
                        )} 

                        error={!!errors?.lEmployer?.preference?.offsetCertificateRenewal}
                        helperText={errors?.lEmployer?.preference?.offsetCertificateRenewal ? errors.lEmployer.preference.offsetCertificateRenewal.message : null}
                    />
                </Grid>
                <Grid item xs={9}>
                </Grid>

            </Grid>
        </Box>

        </React.Fragment>
    );
}
